import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-030dea1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "education-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Education", -1))

import { useStore } from 'vuex'
import { computed, onBeforeMount, ref, watch } from 'vue'
import { EducationItem } from '../../../models/sections/education'
import { v4 as uuid } from 'uuid'
import EducationBlock from './EducationBlock.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EducationSection',
  setup(__props) {

const store = useStore()
const fetchedItems = computed<EducationItem[]>(
  () => store.getters['education/getItems']
)
const items = ref<EducationItem[]>([])

const getKey = (item?: EducationItem): string =>
  'education-item-' + item?.companyTitle + uuid()

watch(fetchedItems, (educationItems) => {
  if (educationItems?.length) {
    items.value = educationItems
  }
})
onBeforeMount(() => store.dispatch('education/getEducationItems'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: getKey(item),
        class: "education-item"
      }, [
        _createVNode(EducationBlock, {
          name: item?.name,
          "degree-title": item?.degreeTitle,
          "graduation-date": item?.graduationDate,
          location: item?.location,
          "relevant-coursework": item?.relevantCoursework
        }, null, 8, ["name", "degree-title", "graduation-date", "location", "relevant-coursework"])
      ]))
    }), 128))
  ]))
}
}

})